<adapt-dialog [maxWidth]="600"
              [expandable]="true"
              [showHelpButton]="false"
              [padding]="false">
    <h3 adapt-dialog-title>Activity feed for {{team.name}} group</h3>

    <div adapt-dialog-content>
        <adapt-team-activity-feed [team]="team"
                                  feedTitle=""></adapt-team-activity-feed>
    </div>

    <adapt-standard-dialog-buttons adapt-dialog-footer
                                   saveButtonPreset="close"
                                   [hideCancelButton]="true"
                                   (saveClick)="cancel()"></adapt-standard-dialog-buttons>
</adapt-dialog>
